import HeaderAttachedBannerContent from './HeaderAttachedBannerContent'

export default HeaderAttachedBannerContent
